// import
import Dashboard from "views/Dashboard/Dashboard";
import Sandbox from "views/Dashboard/Sandbox";
import Indexes from "views/Dashboard/Indexes";
import Support from "views/Dashboard/Support";
import Apis from "views/Dashboard/Apis";
import Connections from "views/Dashboard/Connections";
import Billing from "views/Dashboard/Billing";
import Profile from "views/Dashboard/Profile";
import NewAPI from "views/Dashboard/NewAPI";
import ConfigureAPI from "views/Dashboard/ConfigureAPI";
import APIDetail from "views/Dashboard/APIDetail";
import UsageAlerts from "views/Dashboard/UsageAlerts";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";

import {
	HomeIcon,
	StatsIcon,
	CreditIcon,
	TriformDashboardLogo,
	SandBoxIcon,
	ConnectionsIcon,
} from "components/Icons/Icons";
import { SettingsIcon } from "@chakra-ui/icons/dist/chakra-ui-icons.cjs";
import Settings from "views/Dashboard/Settings";
import IndexDetail from "views/Dashboard/IndexesDetail";
import { IndexesIcon } from "components/Icons/Icons";
import { APISIcon } from "components/Icons/Icons";
import { BillingIcon } from "components/Icons/Icons";
import { SupportIcon } from "components/Icons/Icons";
import ResetPass from "views/Auth/ResetPass";

var dashRoutes = [
	{
		path: "/dashboard",
		name: "Dashboard",
		icon: <TriformDashboardLogo color="inherit" />,
		component: Dashboard,
		layout: "/admin",
	},
	// {
	// 	path: "/profile",
	// 	name: "Profile",
	// 	icon: <HomeIcon color="inherit" />,
	// 	component: Profile,
	// 	layout: "/admin",
	// },
	{
		path: "/sandbox",
		name: "Sandbox",
		icon: <SandBoxIcon color="inherit" />,
		component: Sandbox,
		layout: "/admin",
	},
	{
		path: "/connections",
		name: "Connections",
		icon: <ConnectionsIcon color="inherit" />,
		component: Connections,
		layout: "/admin",
	},
	{
		path: "/indexes/1",
		name: "Indexes Detail",
		component: IndexDetail,
		layout: "/admin",
		redirect: true,
	},

	{
		path: "/indexes",
		name: "Indexes",
		icon: <IndexesIcon color="inherit" />,
		component: Indexes,
		layout: "/admin",
	},

	{
		path: "/apis/usage-alerts",
		name: "Usage Alerts",
		component: UsageAlerts,
		layout: "/admin",
		redirect: true,
	},
	{
		path: "/apis/1",
		name: "API Detail",
		component: APIDetail,
		layout: "/admin",
		redirect: true,
	},
	{
		path: "/apis/new",
		name: "New API",
		component: NewAPI,
		layout: "/admin",
		redirect: true,
	},
	{
		path: "/settings",
		name: "Settings",
		icon: <SettingsIcon color="#E0E0E0" />,
		component: Settings,
		layout: "/admin",
	},

	{
		path: "/apis/configure",
		name: "Configure API",
		component: ConfigureAPI,
		layout: "/admin",
		redirect: true,
	},
	{
		path: "/apis",
		name: "APIS",
		icon: <APISIcon color="inherit" />,
		component: Apis,
		layout: "/admin",
	},
	{
		path: "/billing",
		name: "Billing",
		icon: <BillingIcon color="inherit" />,
		component: Billing,
		layout: "/admin",
	},
	{
		path: "/support",
		name: "Support",
		icon: <SupportIcon color="inherit" />,
		component: Support,
		layout: "/admin",
	},
	{
		path: "/signin",
		name: "Sign In",
		component: SignIn,
		layout: "/auth",
		redirect: true,
	},
	{
		path: "/signup",
		name: "Sign Up",
		component: SignUp,
		layout: "/auth",
		redirect: true,
	},
	{
		path: "/reset-password",
		name: "Reset Password",
		component: ResetPass,
		layout: "/auth",
		redirect: true,
	},
];
export default dashRoutes;
